import { ActionType } from "../../../../../../../react-core/Flux/ActionType";
import { DocumentsSenderAddressClient } from "../../../../../../../Wrap/Api/Documents/DocumentsSenderAddress";
import { ESignatureDocumentSignedClient } from "../../../../../../../Wrap/Api/Documents/ESignatureDocumentSigned";
import { ESignatureDocumentTaskRequestSubmitClient } from "../../../../../../../Wrap/Api/Documents/ESignatureDocumentTaskRequestSubmit";
import { ExternalFundDocumentClient } from "../../../../../../../Wrap/Api/Documents/ExternalFundDocument";
import { InstructionDocumentTypeApplyModelRequestTriggerClient } from "../../../../../../../Wrap/Api/Documents/InstructionDocumentTypeApplyModelRequestTrigger";
import { InstructionDocumentTypeContributionAndWithdrawalBaseRequestTriggerClient } from "../../../../../../../Wrap/Api/Documents/InstructionDocumentTypeContributionAndWithdrawalBaseRequestTrigger";
import { InstructionDocumentTypeInstructionIdRequestTriggerClient } from "../../../../../../../Wrap/Api/Documents/InstructionDocumentTypeInstructionIdRequestTrigger";
import { InstructionDocumentTypeQuoteModelRequestTriggerClient } from "../../../../../../../Wrap/Api/Documents/InstructionDocumentTypeQuoteModelRequestTrigger";
import { DocumentCategory } from "../../../../../../../Wrap/Constants/Enums/Domain/DocumentCategory";
import { ExternalDocumentType } from "../../../../../../../Wrap/Models/Domains/Documents/ExternalDocumentType";
import { SubmitDocumentsEsignature } from "../../../../../../../Wrap/Models/Domains/Documents/SubmitDocumentsEsignature";
import { EsignatureSignedDocuments } from "../../../../../../../Wrap/Models/Models/Documents/InstructionDocuments/EsignatureSignedDocuments";
import { ExternalFundDocument } from "../../../../../../../Wrap/Models/Models/Documents/InstructionDocuments/ExternalFundDocument";
import { ApplyModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { QuoteModel } from "../../../../../../../Wrap/Models/Models/Processes/Quote/QuoteModel";
import { ContributionAndWithdrawalBase } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/ContributionAndWithdrawalBase";
import { IllustrationDispatcher } from "../Store/Variable";

export class InstructionDocumentTypeRequestTriggerActionsCreator {
    public static triggerByApplyModel(applyModel: ApplyModel, callback?): void {
        const client = new InstructionDocumentTypeApplyModelRequestTriggerClient();
        const promise = client.post(applyModel);
        promise.onSuccess((res) => {
            if (callback) {callback(res);}
            IllustrationDispatcher.dispatch({ payload: res, actionType: ActionType.Success });
        });
    }

    public static triggerByQuoteModel(quoteModel: QuoteModel): void {
        const client = new InstructionDocumentTypeQuoteModelRequestTriggerClient();
        const promise = client.post(quoteModel);
        promise.onSuccess((res) => {
            IllustrationDispatcher.dispatch({ payload: res, actionType: ActionType.Success });
        });
    }

    public static triggerByContributionAndWithdrawalBase(
        contribitionAndWithdrawalBase: ContributionAndWithdrawalBase,
        callback?
    ): void {
        const client = new InstructionDocumentTypeContributionAndWithdrawalBaseRequestTriggerClient();
        const promise = client.post(contribitionAndWithdrawalBase);
        promise.onSuccess((res) => {
            if (callback) {
                callback(res);
            }
            IllustrationDispatcher.dispatch({ payload: res, actionType: ActionType.Success });
        });
    }

    public static triggerByInstructionId(
        instructionId: string,
        instructionDocumentCategories: DocumentCategory[]
    ): void {
        const client = new InstructionDocumentTypeInstructionIdRequestTriggerClient();
        const promise = client.post(instructionId, instructionDocumentCategories);
        promise.onSuccess((res) => {
            IllustrationDispatcher.dispatch({ payload: res, actionType: ActionType.Success });
        });
    }

    public static submitEsignatureDocumentRequest(
        actorId: number,
        instructionId: number,
        phoneNumber: string,
        documentTaskRequestIds: number[],
        callBack?: (val: string) => void
    ): void {
        const client = new ESignatureDocumentTaskRequestSubmitClient();
        const eSignatureRequest: SubmitDocumentsEsignature = {
            ActorId: actorId,
            InstructionId: instructionId,
            DocumentTaskRequestIds: documentTaskRequestIds,
            PhoneNumber: phoneNumber,
        };
        const promise = client.post(eSignatureRequest);
        promise.onSuccess((res) => {
            if (callBack) {
                callBack(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getSignedDocumentRequest(
        instructionId: number,
        callBack?: (val: Array<EsignatureSignedDocuments>) => void
    ): void {
        const client = new ESignatureDocumentSignedClient();
        const promise = client.get(instructionId);
        promise.onSuccess((res) => {
            if (callBack) {
                callBack(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getExternalFundDocument(
        accountInstructionId: number,
        customerId: string,
        company: string,
        externalDocumentType: ExternalDocumentType,
        instrumentCodes?: Array<string>,
        callBack?: (val: ExternalFundDocument) => void
    ): void {
        const client = new ExternalFundDocumentClient();
        const promise = client.get(
            Number(accountInstructionId),
            Number(customerId),
            company,
            externalDocumentType,
            instrumentCodes
        );
        promise.onSuccess((res) => {
            if (callBack) {
                callBack(res);
            }
        });
    }

    public static getAddress(callback) {
        const client = new DocumentsSenderAddressClient();
        const promise = client.get();
        promise.onSuccess((res) => {
            if (callback) {
                callback(res);
            }
        });
    }
}
